<template>
    <v-container>
        <v-row class="contentRow">
            <v-col cols="12">
                <h1 class="mb-2">API Keys List</h1>
                <p class="mb-10 text-center">This is a list of API Keys</p>
            </v-col>

            <v-col align="end" cols="12">
                <v-btn
                    color="primary"
                    @click="addApiKey()"
                >
                Add API Key
                </v-btn>
            </v-col>


            <v-col cols="12">
                <v-data-table
                    theme--
                    light
                    :headers="headers"
                    :items="apikeys"
                    :items-per-page="20"
                    class="light table"
					:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"

                >
					<template v-slot:item.delete="{ item }">
						<v-btn color="red" v-on:click="showDeleteDialog(item)">
							<v-icon color="white" small>fas fa-times</v-icon>
						</v-btn>
					</template>
                </v-data-table>
            </v-col>          
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>Are you sure you want to remove this key?</v-card-title>
					<v-card-text>Once it is removed, you cannot retrieve it</v-card-text>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>  
            <v-dialog v-if="dialogAdded" v-model="dialogAdded" max-width="500px">
                <v-card>
                    <v-card-title>A new API Key has been added!</v-card-title>
                    <v-card-text class="font-weight-bold">This message will only be shown once. Please make sure you have written down or saved the secret before closing / exiting this pop-up</v-card-text>

                    <v-card-text>Key: {{newKey.key}}</v-card-text>
					<v-card-text>Secret: {{newKey.secret}}</v-card-text>
                    <v-btn color="primary" text @click="dialogAdded = false">Close</v-btn>

                </v-card>
            </v-dialog>

        </v-row>
    </v-container>
    
</template>

<script>
import LoadingState from "../../consts/LoadingState"
import ApiKeys from "../../api/connections/apikeys"
export default {
	name: "API Keys",
	data() {
		return {
			headers: [
				{text: "API Key", value: "key", sortable: false},
				{text: "Secret", value: "secret", sortable: false},
				{text: "Delete", value:"delete", sortable: false}
			],
			apikeys: [],
			itemToDelete: null,
			dialogDelete: false,
			dialogAdded: false,
			newKey: null
		}
	},
	mounted() {
		this.fetchAPI()
	},
	methods: {
		addApiKey: function() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Adding API Key...",
				{ root: true}
			)
			ApiKeys.addApiKey()
				.then((returnValue) => {
					this.fetchAPI()

					this.newKey = returnValue
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Added API Key " + returnValue.key,
						{ root: true}
					)
					this.dialogAdded = true
				}).catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true}
					)
				})
		},
		fetchAPI: function() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Retrieving Users...",
				{ root: true}
			)
			ApiKeys.getAPIkeys().then((rawdata) => {
				this.apikeys = []
				for (let element of rawdata) {
					this.apikeys.push({
						key: element.key,
						secret: "******",
						remove: null
					})
				}
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_END_LOADING,
					null,
					{ root: true }
				)
			}).catch(error => {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					error,
					{ root: true}
				)
			})

		},
		showDeleteDialog: function(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		}, 
		removeRow: function() {
			this.dialogDelete = false
			// let index = this.apikeys.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			ApiKeys.deleteApiKey(this.itemToDelete.key)
				.then(() => {
					this.fetchAPI()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Successfully deleted API Key " + this.itemToDelete.key,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true}
					)
				})
		} 


	}
}
</script>